import React from 'react';
import { useParameterizedQuery } from 'react-fetching-library';
import { Box } from '@mui/material';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridToolbar } from '../../../../components/data-grid/DataGridToolbar';
import Scrollbar from '../../../../components/Scrollbar';
import { workStandardColumns } from '../../../../services/column-definitions';
import ConfirmDelete from './ConfirmDelete';
import toast from 'react-hot-toast';
import DocumentForm from './DocumentForm';
import PDFPreviewModal from '../../applications/applicationForm/tabs/documents/PDFPreviewModal';

export default function WorkStandardList(
  { documents, queryCallback, setDocuments, downloadDocumentAction,
    deleteDocumentAction, submitDocumentAction, getDocumentsAction,
    page, setPage, pageSize, setPageSize, count, setCount }) {
  const [fileDocument, setFileDocument] = React.useState({});
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const { query } = useParameterizedQuery(downloadDocumentAction);

  const handleDownload = async (row, preview = false) => {
    const { payload, error, loading } = await query(row.id);
    if (!error && !loading) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${row.file_name}`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } else {
      toast.error('Nie udało się pobrać pliku');
    }
  };

  const handleOpenDeleteModal = row => {
    setFileDocument(row);
    setOpenDeleteModal(true);
  };

  const handleOpenEditModal = row => {
    setFileDocument(row);
    setOpenEditModal(true);
  };

  const searchCallback = search => {
    queryCallback({ search, page: 0, page_size: pageSize }); // reset do pierwszej strony przy wyszukiwaniu
    setPage(0);
  };

  const handlePageChange = newPage => {
    setPage(newPage);
  };

  const handlePageSizeChange = newPageSize => {
    setPageSize(newPageSize);
    setPage(0);
  };

  return (
    <Scrollbar>
      <Box sx={{ minWidth: { md: 800 }, mt: 4 }}>
        <DataGridPro
          columns={workStandardColumns(handleDownload, handleOpenDeleteModal, handleOpenEditModal)}
          rows={documents}
          rowCount={count}
          page={page}
          pageSize={pageSize}
          pagination
          paginationMode="server"
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          density="standard"
          disableColumnMenu={true}
          autoPageSize={false}
          autoHeight={true}
          rowsPerPageOptions={[10, 25, 50, 100]}
          components={{
            Toolbar: DataGridToolbar
          }}
          componentsProps={{ toolbar: { miniView: true, searchCallback } }}
          localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
          disableSelectionOnClick

        />
      </Box>
      {openDeleteModal ? <ConfirmDelete
        document={document}
        handleClose={() => setOpenDeleteModal(false)}
        setDocuments={setDocuments}
        deleteDocumentAction={deleteDocumentAction}
        setCount={setCount}
      /> : null}
      {openEditModal && <DocumentForm
        open={openEditModal}
        document={fileDocument}
        handleClose={() => setOpenEditModal(false)}
        setDocuments={setDocuments}
        submitDocumentAction={submitDocumentAction}
        getDocumentsAction={getDocumentsAction}
        setCount={setCount}
      />}
      {previewUrl && <PDFPreviewModal url={previewUrl} handleClose={() => setPreviewUrl(null)}/> }
    </Scrollbar>
  );
};
